export default __webpack_public_path__ + "media/images/landing-25-550x420-94e0952d4784e731534f84c91b0d328e.jpg";